import { render, staticRenderFns } from "./productCollection.vue?vue&type=template&id=07775157&"
import script from "./productCollection.vue?vue&type=script&lang=js&"
export * from "./productCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports